// function timeLeftUntil2PM() {
//   // Get the current time, and adjust it to UK timezone
//   let now = new Date().toLocaleString("en-US", { timeZone: "Europe/London" });
//   let ukTime = new Date(now);

//   let cutOffTime = parseInt(window.customStrings.countdownCutoff)


//   let currentDay = ukTime.getDay(); // days are 0-6 where 0 is Sunday and 6 is Saturday
//   let currentHours = ukTime.getHours();
//   let currentMinutes = ukTime.getMinutes();
//   let currentSeconds = ukTime.getSeconds();

//   // Special case for weekend: From Friday 2pm to Monday 12am, we show "It's past 2pm"
//   if ((currentDay === 5 && currentHours >= 14) ||  // from Friday 2pm
//       currentDay === 6 ||                          // all Saturday
//       currentDay === 0 ||                          // all Sunday
//       (currentDay === 1 && currentHours < 12)) {   // until Monday 12am
//       return "";
//   }

//   // For other times, we calculate the remaining time until 2pm
//   if (currentHours < 14) {
//       // Calculate the remaining time until 2 PM
//       let hoursLeft = 13 - currentHours; // Since the current hour is not complete, we subtract from 13
//       let minutesLeft = 60 - currentMinutes;
//       let secondsLeft = 60 - currentSeconds;

//       if (minutesLeft === 60) {
//           hoursLeft -= 1;  // Adjust hour if 60 minutes are left
//           minutesLeft = 0;
//       }
//       if (secondsLeft === 60) {
//           minutesLeft -= 1;  // Adjust minutes if 60 seconds are left
//           secondsLeft = 0;
//       }

//       // Create the display string
//       let timeString = `${hoursLeft}h:${minutesLeft}mins:${secondsLeft}secs left for next day delivery.`;

//       // Return the time left
//       return timeString;
//   } else {
//       // If the current time is not between 12 AM and 2 PM, we don't need to show the countdown
//       return "It's past 2 PM.";
//   }
// }

// // Function to update countdown every second
// function updateCountdown() {
//   const countdowns = document.querySelectorAll(".js-countdown");

//   countdowns.forEach((countdown) => {
//       countdown.innerHTML = timeLeftUntil2PM();
//   });
// }

// // Update the countdown every second
// setInterval(updateCountdown, 1000);



function timeLeftUntilCustomCutoff() {
    // Ensure window.customStrings.countdownCutoff is set, or default to 14 (for 2 PM)
    let cutOffTime = (window.customStrings && parseInt(window.customStrings.countdownCutoff)) || 14;
    // cutOffTime = 1
    
    // Validate cutOffTime, it should be between 0 and 23
    if (cutOffTime < 0 || cutOffTime > 23) {
      console.error("Invalid cutoff time. Please ensure it's between 0 (12 AM) and 23 (11 PM).");
      return "";
    }
  
    // Get the current time, and adjust it to UK timezone
    let now = new Date().toLocaleString("en-US", { timeZone: "Europe/London" });
    let ukTime = new Date(now);
  
    let currentDay = ukTime.getDay(); // days are 0-6 where 0 is Sunday and 6 is Saturday
    let currentHours = ukTime.getHours();
    let currentMinutes = ukTime.getMinutes();
    let currentSeconds = ukTime.getSeconds();
  
    // Check the time and day conditions
    if ((currentDay === 5 && currentHours >= cutOffTime) || // from Friday cutOffTime
        currentDay === 6 ||                                // all Saturday
        currentDay === 0 ||                                // all Sunday
        (currentDay === 1 && currentHours < 12)) {         // until Monday 12am
        return "";
    }
  
    if (currentHours < cutOffTime) {

        // Calculate the remaining time until cutOffTime
        let hoursLeft = (cutOffTime - 1) - currentHours; 
        let minutesLeft = 60 - currentMinutes;
        let secondsLeft = 60 - currentSeconds;
  
        if (minutesLeft === 60) {
            hoursLeft += 1; // Adjust hour if 60 minutes are left
            minutesLeft = 0;
        }
        if (secondsLeft === 60) {
            minutesLeft += 1; // Adjust minutes if 60 seconds are left
            secondsLeft = 0;
        }
  
        // Create the display string
        let timeString = `${hoursLeft}h:${minutesLeft}mins:${secondsLeft}secs left for next day delivery.`;
  
        // Return the time left
        return timeString;
    } else {
  
        timeString = "";
        
        document.querySelectorAll(".header-countdown").forEach((countdown) => {
    
           countdown.style.display = "none"; 
        })

        document.querySelectorAll(".js-countdown").forEach((countdown) => {
      
           countdown.style.display = "none"; 
        })
        
        

        

        // Past the cutoff, show appropriate message
        // return `It's past ${cutOffTime === 12 ? 12 : (cutOffTime % 12)} ${cutOffTime < 12 || cutOffTime === 24 ? 'AM' : 'PM'}.`;
    }
  }
  
  // Function to update countdown every second
  function updateCountdown() {
    const countdowns = document.querySelectorAll(".js-countdown");


  
    countdowns.forEach((countdown) => {
        countdown.innerHTML = timeLeftUntilCustomCutoff();
    });
  }
  
  // Update the countdown every second
  setInterval(updateCountdown, 1000);
  
